var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"world-cloud-3d"},[_c('div',{staticClass:"world-cloud-canvas-wrapper"},[_c('canvas',{attrs:{"id":"world-cloud-canvas","width":"800","height":"574"}})]),_c('div',{attrs:{"id":"weightTags"}})])
}]

export { render, staticRenderFns }